import dayjs from "dayjs"
import React from "react"
import { generateClassName } from "src/lib/utils/generate-class-name"
import * as styles from "./List.css"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

type Props = {
  className?: string
  items: [string, string | number | JSX.Element][]
}

export const formatDate = (d: string | Date) => {
  // jst
  dayjs.extend(utc)
  dayjs.extend(timezone)
  return dayjs(d).tz("Asia/Tokyo").format("YYYY/MM/DD HH:mm:ss")
}

const Component: React.VFC<Props> = (props) => {
  const className = generateClassName("List", [styles.root, props.className])

  return (
    <ul className={className}>
      {props.items.map(([title, content]) => {
        return (
          <li className={styles.item} data-title={title} key={title}>
            <span className={styles.itemTitle}>{title}</span>
            <span className={styles.itemContent}>{content}</span>
          </li>
        )
      })}
    </ul>
  )
}

export const List = Component
